module.exports = __webpack_public_path__ + "static/media/flight-title-kyushu.d2306444.svg";